import axios from 'axios';

export const getAppsheetDealerContext = async ({ bac, includeTrade = false }) => {
    if (!bac) {
        throw new Error('bac is required');
    }
    const params = {};
    if (includeTrade) {
        params.includeTrade = true;
    }
    const { data } = await axios.get(`/api/appsheet/dealer/${encodeURIComponent(bac)}`, { params });
    return data;
};

export const getAppSheetStatusChangeMetrics = async (options = {}) => {
    const params = {};
    if (options.programName) {
        params.programName = options.programName;
    }
    const { data } = await axios.get('/api/appsheet/status-changes/metrics', { params });
    return data;
};

export const getAppSheetStatusChanges = async (options = {}) => {
    const params = {};
    if (options.programName) {
        params.programName = options.programName;
    }
    if (options.rowKey) {
        params.rowKey = options.rowKey;
    }
    if (options.startDate) {
        params.startDate = options.startDate;
    }
    if (options.endDate) {
        params.endDate = options.endDate;
    }
    if (options.limit) {
        params.limit = options.limit;
    }
    if (options.offset !== undefined) {
        params.offset = options.offset;
    }
    const { data } = await axios.get('/api/appsheet/status-changes', { params });
    return data;
};
